import React, { useState } from "react";
// interfaces
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
// componentes
import Button from "../../atoms/button/button";
import RichtextDescription from "../../atoms/richtext-description/richtextDescription";
// estilos
import "./frequentQuestions.scss";

// Este componente es para las preguntas frecuentes, que son independentes (seccion, seccion)
const FrequentQuestions = (props: ReferenciaContenido) => {
  const [showanswerdes, setquesanswer] = useState(-1);
  const changeanswers = (dess: number) => {
    setquesanswer(showanswerdes === dess ? -1 : dess);
  };

  return (
    <div className="m-frequentlyV2">
      <h2> {props.tituloGeneral} </h2>
      <div className="m-frequentlyV2-questions">
        {props.referenciaPlantillaContenido.map((elem, indexpo) => {
          const description = elem.descripcion;

          return (
            <div
              className={`m-questions`}
              key={elem.tituloBanner.replace(" ", "")}
            >
              <div
                className={`m-questions-title ${
                  indexpo === showanswerdes ? "m-questions-title-show" : ""
                } `}
                onClick={() => changeanswers(indexpo)}
              >
                <h3>{elem.tituloBanner}</h3>
                <button
                  type="button"
                  onClick={() => changeanswers(indexpo)}
                  aria-label={elem.tituloBanner}
                >
                  <i
                    className={`m-questions-icon ${
                      indexpo === showanswerdes
                        ? "icon-minus-thin"
                        : "icon-plus-thin"
                    }`}
                  />
                </button>
              </div>
              <div className={`m-questions-description`}>
                <RichtextDescription descripcion={description} />
              </div>
            </div>
          );
        })}
      </div>
      {props.tituloBoton && (
        <div className="m-frequentlyV2-button">
          <Button
            type={"link"}
            classname={`primary`}
            text={props.tituloBoton}
            href={props.redireccionBoton}
            isDisabled={false}
          />
        </div>
      )}
    </div>
  );
};
export default FrequentQuestions;
